import { Record, List } from 'immutable';
import isValidJson from '../../util/isValidJson';
import isValidCron from '../../util/isValidCron';

class JobSpec extends Record(
  {
    name: '',
    jobTasks: new List(),
    scheduledUserOptions: new List(),
    scheduledUser: '',
    scheduleCron: '',
  }) {

  // Transform into submittable JSON
  get toGiraffe() {
    const taskSetAsJSON = this.jobTasks.map(task => task.toGiraffe);
    const wrappedTasks = {
      jobType: 'giraffe',
      config: taskSetAsJSON,
    };
    return wrappedTasks;
  }

  get valid() {
    try {
      return this._validJson && this._validSchedule;
    } catch (e) {
      return false;
    }
  }

  get _validSchedule() {
    // If scheduleCron and scheduledUser are both set, confirm they're both valid
    // Elseif scheduled User is set, confirm the scheduled user is valid
    // Else confirm there's no cron
    if (this.scheduleCron && this.scheduledUser) {
      return this._validCron && this._validScheduledUser;
    } else if (this.scheduledUser) {
      // Validating the user should be an API concern, right?
      return this._validScheduledUser;
    }
    return !this.scheduleCron;
  }

  get _validCron() {
    return isValidCron(this.scheduleCron);
  }

  get _validScheduledUser() {
    return this.scheduledUserOptions.map(user => user.email)
                                    .indexOf(this.scheduledUser) !== -1;
  }

  get _validJson() {
    return isValidJson(JSON.stringify(this.toGiraffe));
  }
}

export default JobSpec;
